import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
    activebtn?: string;
}

export const Label = styled(Box)(
    ({ theme }: ParamsStyle) => `
        .title {
            font-size: .75rem;
            color: ${theme?.palette.primary.main};
        }

        .description {
            font-size: 1rem;
            margin-top: .5rem;
            color: ${theme?.palette.grey[400]};
        }

        label {
            display: flex;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);